import { supabase } from '../lib/supabase';

interface EmailPayload {
  to: string;
  subject: string;
  html?: string;
  text?: string;
  from?: string;
}

export const emailService = {
  sendEmail: async (payload: EmailPayload) => {
    try {
      console.log('Sending email via Supabase function:', {
        to: payload.to,
        subject: payload.subject,
        from: payload.from
      });

      const { data, error } = await supabase.functions.invoke('send-email', {
        body: payload
      });

      if (error) {
        console.error('Supabase function error:', error);
        throw new Error(`Email service error: ${error.message}`);
      }

      console.log('Email sent successfully:', data);
      return data;
    } catch (error) {
      console.error('Email service error:', error);
      throw error;
    }
  },

  sendInvitation: async (to: string, projectName: string, projectUrl: string, inviterName: string = 'Project Owner', guestPassword: string) => {
    const subject = `${inviterName} invited you to collaborate on ${projectName}`;
    const html = `
      <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
        <h2 style="color: #4F46E5;">You've been invited to collaborate!</h2>
        <p>Hi there,</p>
        <p>${inviterName} has invited you to view and add comments on their project <strong>${projectName}</strong>.</p>
        
        <div style="background-color: #f8f9fa; padding: 20px; border-radius: 8px; margin: 20px 0;">
          <p><strong>Project:</strong> ${projectName}</p>
          <p><strong>Access Password:</strong> <code style="background-color: #e9ecef; padding: 2px 6px; border-radius: 4px;">${guestPassword}</code></p>
        </div>

        <p>To view the comments:</p>
        <ol>
          <li>Visit the website: <a href="${projectUrl}" style="color: #4F46E5;">${projectUrl}</a></li>
          <li>Look for the FeedbackFlow widget on the page</li>
          <li>Enter the access password when prompted</li>
        </ol>

        <div style="margin: 30px 0;">
          <a href="${projectUrl}" style="background-color: #4F46E5; color: white; padding: 12px 24px; text-decoration: none; border-radius: 6px; display: inline-block; font-weight: 500;">
            View Project →
          </a>
        </div>

        <p style="color: #6b7280; font-size: 14px;">
          Best regards,<br>
          The FeedbackFlow Team
        </p>
      </div>
    `;

    return emailService.sendEmail({
      to,
      subject,
      html,
      from: 'FeedbackFlow <notifications@minidev.pro>'
    });
  },

  sendPasswordChangeNotification: async (to: string) => {
    return emailService.sendEmail({
      to,
      subject: 'Your password has been changed',
      html: `
        <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
          <h2 style="color: #4F46E5;">Password Changed</h2>
          <p>Your password has been successfully changed.</p>
          <p>If you did not make this change, please contact support immediately.</p>
          
          <p style="color: #6b7280; font-size: 14px;">
            Best regards,<br>
            The FeedbackFlow Team
          </p>
        </div>
      `,
      from: 'FeedbackFlow <security@minidev.pro>'
    });
  },

  async sendSupportEmail({ from, subject, message }: { from: string; subject: string; message: string }) {
    return emailService.sendEmail({
      to: 'support@minidev.pro',
      subject: `Support Request: ${subject}`,
      html: `
        <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
          <h2>Support Request from ${from}</h2>
          <p><strong>Subject:</strong> ${subject}</p>
          <p><strong>Message:</strong></p>
          <div style="background-color: #f8f9fa; padding: 20px; border-radius: 8px; margin: 20px 0;">
            ${message.replace(/\n/g, '<br>')}
          </div>
        </div>
      `,
      from: 'FeedbackFlow <notifications@minidev.pro>'
    });
  }
}; 